module.exports = __webpack_public_path__ + "static/media/Archivo-Regular.8becc89a.ttf";